import { c as _c } from "react/compiler-runtime";
import { Button, type SxProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ButtonProps } from './ButtonProps';
import { defaultButtonStyles } from './defaultButtonStyles';
export function TertiaryButton(props) {
  const $ = _c(3);
  const t0 = props.color || "primary";
  let t1;
  if ($[0] !== props || $[1] !== t0) {
    t1 = <TertiaryButtonStyled variant="text" {...props} role="button" color={t0}>{props.text}</TertiaryButtonStyled>;
    $[0] = props;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
const TertiaryButtonStyled = styled(Button, {})(({
  theme
}) => ({
  ...defaultButtonStyles,
  ...({
    '&:active': {
      border: `1px solid ${theme.palette.action.active}`,
      color: theme.palette.action.active
    },
    '&:hover': {
      border: `1px solid ${theme.palette.primary.dark}`,
      color: theme.palette.primary.dark
    },
    '&.Mui-disabled': {
      border: `0px solid ${theme.palette.action.disabled}`,
      color: theme.palette.action.disabled
    }
  } as SxProps)
}));